'use client';
import RadioBoxSimple from '@/components/shared/radio-box-simple/radio-box-simple.component';

import SwipeableDrawer from '@/components/shared/bottom-sheet/bottom-sheet.component';

import Typography from '@/components/shared/typography/typography.component';
import { FC, useState } from 'react';
import { CloseButtonIcon } from '../../../../public/Images';
import { useSort, useTranslation } from '@/hook';
import { SORTING_PLANS } from '@/types/filter.types';

const SortMobile: FC<{
    open: boolean;
    setOpen: (open: boolean) => void;
}> = ({ open, setOpen }) => {
    const { t } = useTranslation();
    const { setSortOptions, sorting_plan } = useSort();

    const sortData: { [key in SORTING_PLANS]?: string } = {
        [SORTING_PLANS.MOST_RELEVANT]: t('Most Relevant'),
        [SORTING_PLANS.RECENTLY_ADDED]: t('Recently Added'),
        [SORTING_PLANS.PRICE_DESC]: t('Price - Highest to Lowest'),
        [SORTING_PLANS.PRICE_ASC]: t('Price - Lowest to Highest'),
        [SORTING_PLANS.KM_DESC]: t('KMs - Highest to Lowest'),
        [SORTING_PLANS.KM_ASC]: t('KMs - Lowest to Highest'),
        [SORTING_PLANS.YEAR_ASC]: t('Year - Old to New'),
        [SORTING_PLANS.YEAR_DESC]: t('Year - New to Old'),
    };
    const [selectedSort, setSelectedSort] =
        useState<SORTING_PLANS>(sorting_plan);

    const sortItemClicked = (selectedSorting: string) => {
        setSelectedSort(SORTING_PLANS[selectedSorting]);
    };
    const applySort = () => {
        setSortOptions(selectedSort);
        setOpen(false);
    };
    return (
        <SwipeableDrawer open={open} setOpen={setOpen}>
            <div
                style={{
                    height: '66vh',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '16px',
                    position: 'relative',
                }}
            >
                <div
                    style={{
                        display: 'grid',
                        alignItems: 'center',
                        gridTemplateColumns: '7% 86%',
                    }}
                >
                    <img
                        src={CloseButtonIcon.src}
                        onClick={() => setOpen(false)}
                        alt="close-btn"
                    />
                    <Typography
                        style={{ justifySelf: 'center' }}
                        variant="subtitle2Medium"
                    >
                        {t('sortBy')}
                    </Typography>
                </div>
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '4px',
                        height: '100%',
                        overflow: 'scroll',
                    }}
                >
                    {Object.keys(sortData).map(item => (
                        <RadioBoxSimple
                            key={item}
                            variant="row-reverse"
                            text={sortData[item]}
                            selected={selectedSort === item}
                            value={item}
                            radioBoxClicked={sortItemClicked}
                        />
                    ))}
                </div>
                <div
                    style={{
                        height: '92px',
                        backgroundColor: 'white',
                        width: '100%',
                    }}
                >
                    <button
                        style={{ height: '80%' }}
                        onClick={() => applySort()}
                        className="sylndr_button primary"
                    >
                        {t('Apply')}
                    </button>
                </div>
            </div>
        </SwipeableDrawer>
    );
};

export default SortMobile;
